import React from "react";
import { connect } from "react-redux";
import PropTypes from 'prop-types';
import { Radio, Collapse } from "antd";
import formatter from '../../../../utils/formatter';
import Preloader from "../../../../CommonComponents/Preloader/Preloader";
import { milliToDate, formatShares } from '../../../../utils/commonUtil';
import { exportTxnData } from "../../Pages/actions";
import PrintTable from "../../../../CommonComponents/PrintTable/PrintTable";
import { TableData } from "../TransactionDetailsTable/styles.js";
import { isIfTiff, isIfLcp, getParenthesis } from '../../Pages/txnUitls';

export const CommonTabContentPrint = props => {
  const renderOption = (data) => {
    let newprintdata;
    if (data.option && data.option.length > 0) {
      newprintdata = data.option.map((opt) => {
         return  opt.pool ? <TableData> { opt.pool } </TableData> : <TableData> - </TableData> 
        })
    }
    if (data.value && data.value.length > 0) {
      newprintdata = data.value.map((val) => {
        let amount = 0;
        amount = formatter({
          value: val.value,
          fieldSuffix: 'Dollars',
        })
          return  amount ?  <TableData>  {data.type === 'from' ? `(${amount})` : amount} </TableData> : <TableData> - </TableData>
      })
    }
    return newprintdata;
  }

 const renderPrintData = (data,tab) => {
    let modifiedData = [];
    data.map((value) => {
      
      if(value.hasOwnProperty('enteredDate')){
        value.enteredDate = milliToDate(value.enteredDate);
      }
      if(value.hasOwnProperty('tradeDate')){
        value.tradeDate = milliToDate(value.tradeDate);
      } 
      if(value.hasOwnProperty('receivedDate')){
        value.receivedDate = milliToDate(value.receivedDate);
      }
      if(tab === 'OtherTransactions'){
        let dollarsAmount = formatter({
          value:  value.amount,
          fieldSuffix: 'Dollars',
        });
        value.amount = value.decrease ? `(${dollarsAmount})` : dollarsAmount;
      }
       if(tab === 'Grants'){
        if(value.hasOwnProperty('purpose')){
          value.purposePrint = value.purpose.description;
        }
        let dollarsAmount = formatter({
          value:  value.amount,
          fieldSuffix: 'Dollars',
        });
        value.amount = value.reversal ? dollarsAmount : `(${dollarsAmount})`;
       }
       if(tab === 'AllTransactions'){
        let dollarsAmount = formatter({
          value: value.amount,
          fieldSuffix: 'Dollars',
        })
        const isParenthesis = getParenthesis(value)
        value.amount = isParenthesis ? `(${dollarsAmount})`: dollarsAmount;
       }
       if(tab === 'Contributions'){
        let dollarsAmount = formatter({
          value: value.amount,
          fieldSuffix: 'Dollars',
        })
        value.amount = dollarsAmount ? value.status === "Reversed" ? `(${dollarsAmount})` : dollarsAmount : '-';
        value.noOfShares = value.noOfShares ? formatShares(value.noOfShares,''): '-';
       }
       if(tab === 'Exchanges'){
        if (value.fromInvestmentOption) {
          modifiedData.push({
            enteredDate: value.enteredDate,
            investmentOption: renderOption({ 'type': 'from', 'option': value.fromInvestmentOption }),
            option: value.fromInvestmentOption.length > 0 ? value.fromInvestmentOption[0].pool : "-",
            amount: value.fromInvestmentOption.length > 0 ? value.fromInvestmentOption[0].value : 0,
            value:  renderOption({ 'type': 'from', 'value': value.fromInvestmentOption }),
            tradeDate: value.tradeDate,
            transactionId: value.transactionId,
            tiffType: value.tiff && isIfTiff(value.fromInvestmentOption) ? 'from' : null,
            allocationType: value.allocationType,
            exchangesType: value.exchangesType,
            recurring: value.recurring,
            status: value.status,
            isLcpIncluded: isIfLcp(value.toInvestmentOption || []) || isIfLcp(value.fromInvestmentOption)
          });
        }
        if (value.toInvestmentOption) {
          modifiedData.push({
            enteredDate: value.enteredDate,
            investmentOption: renderOption({ 'type': 'to', 'option': value.toInvestmentOption }),
            option: value.toInvestmentOption[0].pool,
            amount: value.toInvestmentOption[0].value,
            value: renderOption({ 'type': 'to', 'value': value.toInvestmentOption }),
            tradeDate: value.tradeDate,
            transactionId: value.transactionId,
            tiffType: value.tiff && isIfTiff(value.toInvestmentOption) ? 'into' : null,
            allocationType: value.allocationType,
            exchangesType: value.exchangesType,
            recurring: value.recurring,
            status: value.status,
            isLcpIncluded: isIfLcp(value.toInvestmentOption) || isIfLcp(value.fromInvestmentOption || [])
          });
        }
       } else{
      modifiedData.push(value);
       }
      }
    )
    return modifiedData;
  }
 
  const tabTableData = () => {
    let printData = props.txnPrintData;
    let allTransactionDataCols = [
      {
        title: "Transaction ID",
        dataIndex: "transactionId",
        key: "transactionId"
      },
      {
        title: "Entered Date",
        dataIndex: "enteredDate",
        key: "enteredDate"
      },
      {
        title: "Type",
        dataIndex: "tabType",
        key: "tabType"
      },
      {
        title: "Dollar Amount",
        dataIndex: "amount",
        key: "amount"
      }, 
      {
        title: "Trade Date",
        dataIndex: "tradeDate",
        key: "tradeDate"
      }
    ];

    let contributionsDataCols = [
      {
        title: "Transaction ID",
        dataIndex: "transactionId",
        key: "transactionId"
      },
      {
        title: "Entered Date",
        dataIndex: "enteredDate",
        key: "enteredDate"
      },
      {
        title: "Description",
        dataIndex: "description",
        key: "description"
      },
      {
        title: "Shares",
        dataIndex: "noOfShares",
        key: "noOfShares"
      },
      {
        title: "Amount",
        dataIndex: "amount",
        key: "amount"
      }, 
      {
        title: "Received Date",
        dataIndex: "receivedDate",
        key: "receivedDate"
      }, 
      {
        title: "Trade Date",
        dataIndex: "tradeDate",
        key: "tradeDate"
      }
    ];

    let exchangesDataCols = [
      {
        title: "Transaction ID",
        dataIndex: "transactionId",
        key: "transactionId"
      },
      {
        title: "Entered Date",
        dataIndex: "enteredDate",
        key: "enteredDate"
      },
      {
        title: "Investment Option",
        dataIndex: "investmentOption",
        key: "investmentOption"
      },
      {
        title: "Amount",
        dataIndex: "value",
        key: "value"
      }, 
      {
        title: "Trade Date",
        dataIndex: "tradeDate",
        key: "tradeDate"
      }
    ];

    let otherTransactionsDataCols = [
      {
        title: "Transaction ID",
        dataIndex: "transactionId",
        key: "transactionId"
      },
      {
        title: "Entered Date",
        dataIndex: "enteredDate",
        key: "enteredDate"
      },
      {
        title: "Description",
        dataIndex: "description",
        key: "description"
      },
      {
        title: "Type",
        dataIndex: "type",
        key: "type"
      },
      {
        title: "Dollar Amount",
        dataIndex: "amount",
        key: "amount"
      }, 
      {
        title: "Trade Date",
        dataIndex: "tradeDate",
        key: "tradeDate"
      }
    ];

    let grantsDataCols = [
      {
        title: "Transaction ID",
        dataIndex: "transactionId",
        key: "transactionId"
      },
      {
        title: "Entered Date",
        dataIndex: "enteredDate",
        key: "enteredDate"
      },
      {
        title: "Charity Name",
        dataIndex: "charityName",
        key: "charityName"
      },
      {
        title: "Interested Area",
        dataIndex: "interestArea",
        key: "interestArea"
      },
      {
        title: "Amount",
        dataIndex: "amount",
        key: "amount"
      }, 
      {
        title: "Purpose",
        dataIndex: "purposePrint",
        key: "purposePrint"
      },
      {
        title: "Trade Date",
        dataIndex: "tradeDate",
        key: "tradeDate"
      }
    ];
    switch (props.tabType) {
      case 'Exchanges':
        if (props.loadingPrintData.Exchanges) {
          return <Preloader />
        }
        return (
          <PrintTable
            dataSource={renderPrintData(printData.Exchanges.data,props.tabType)}
            columns={exchangesDataCols}
          />
        );
      case 'OtherTransactions':
        if (props.loadingPrintData.OtherTransactions) {
          return <Preloader />
        }
        return (
          <PrintTable
            dataSource={renderPrintData(printData.OtherTransactions.data,props.tabType)}
            columns={otherTransactionsDataCols}
          />)
      case 'Grants':
        if (props.loadingPrintData.Grants) {
          return <Preloader />
        }
        return (
          <PrintTable
            dataSource={renderPrintData(printData.Grants.data,props.tabType)}
            columns={grantsDataCols}
          />);
      case 'Contributions':
        if (props.loadingPrintData.Contributions) {
          return <Preloader />
        }
        return (
          <PrintTable
            dataSource={renderPrintData(printData.Contributions.data,props.tabType)}
            columns={contributionsDataCols}
          />
        );
      default:
        if (props.loadingPrintData.AllTransactions) {
          return <Preloader />
        }
        
        return (
          <PrintTable
          columns={allTransactionDataCols}
          dataSource={renderPrintData(printData.AllTransactions.data,props.tabType)}
          />
        );   
    }
  };
      return ( tabTableData() );
};


CommonTabContentPrint.propTypes = {
  tabType: PropTypes.string,
  txnPrintData: PropTypes.object,
  loadingPrintData: PropTypes.object
}

const mapStateToProps = state => ({
  txnPrintData: state.getIn(["transactionSummary", "txnPrintData"]).toJS(),
  loadingPrintData:  state.getIn(["transactionSummary", "loadingPrintData"]).toJS()
});

export default connect(mapStateToProps, null)(CommonTabContentPrint);